<div class="mt-4" >
  <ol class="col-sm breadcrumb bg-white">
    <li class="breadcrumb-item"><button class="btn btn-sm btn-link" disabled>Réceptions</button></li>
  </ol>
</div>


<div class="my-3 p-3 bg-white rounded shadow-sm">
  <div class="input-group mb-4">
    <div class="input-group-prepend">
      <span class="input-group-text"><i class="bi bi-search"></i></span>
    </div>
    <input type="text" class="form-control" placeholder="Recherche" [(ngModel)]="searchRequest.query" (keyup)="querySearch()"/>

    <div class="input-group-append">
      <supplier-search-criteria class="input-group-append"></supplier-search-criteria>
    </div>
    <button class="ml-3 btn btn-outline-primary" (click)="openNewReceptionModal()">Nouvelle réception</button>
  </div>

  <div class="btn-toolbar">
    <div class="input-group pr-2 pb-2" *ngIf="searchRequest.getValues('supplier').length > 0">
      <div class="input-group-prepend">
        <div class="btn btn-secondary btn-sm">{{ displaySupplierFilter() }}</div>
      </div>
      <div class="input-group-append">
        <button class="btn btn-secondary btn-sm" type="button" (click)="clearSupplier()" >X</button>
      </div>
    </div>
  </div>

  <div class="border-bottom"></div>
  
  <search-paging [searchComponent]="this"></search-paging>

  <table class="table table-sm text-center" *ngIf="results">
    <thead>
      <tr>
        <th>Fournisseur</th>
        <th>Facture</th>
        <th>Date de création</th>
        <th>Status</th>
        <th>Références</th>
        <th>&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <tr class="container-fluid text-center"*ngFor="let reception of results.content">
        <td>{{ reception.supplier.name }}</td>
        <td>
          <button class="btn btn-sm btn-link" [routerLink]="['/purchase/invoice', reception.invoiceId]" *ngIf="reception.supplierInvoiceNumber">
            <span >{{ reception.supplierInvoiceNumber }}</span>
          </button>
        </td>
        <td>{{ reception.creationTimestamp | date: 'medium' }}</td>
        <td><reception-status [status]="reception.status"></reception-status></td>
        <td>{{ reception.references }} référence(s)</td>
        <td><button class="btn btn-sm btn-outline-primary m-2" (click)="openReception(reception)"><span class="bi bi-file-text"></span></button></td>
      </tr>
    </tbody>
  </table>

  <search-paging [searchComponent]="this"></search-paging>
</div>

